import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaArrowRight,
  FaStar,
  FaPlay,
  FaShieldAlt,
  FaClock,
  FaCheckCircle,
  FaMedal,
  FaHandshake,
  FaRocket,
} from "react-icons/fa";
import "../styles/HeroSection.css";

// Import background images
import bg1 from "../assets/a2.png";
import bg2 from "../assets/a7.png";
import bg3 from "../assets/dit3.png";
import bg4 from "../assets/c1.png";
import bg5 from "../assets/a3.png";
import bg6 from "../assets/n5.png";

const HeroSection = () => {
  const [currentBg, setCurrentBg] = useState(0);

  const backgroundImages = [bg1, bg2, bg3, bg4, bg5, bg6];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const stats = [
    { value: "5000+", label: "Cases Solved", icon: <FaCheckCircle /> },
    { value: "98%", label: "Success Rate", icon: <FaStar /> },
    { value: "24/7", label: "Emergency Support", icon: <FaClock /> },
    { value: "50+", label: "Expert Detectives", icon: <FaShieldAlt /> },
  ];

  return (
    <section className="hero-new">
      {/* Background Image */}
      <div className="hero-new-bg">
        {backgroundImages.map((img, index) => (
          <div
            key={index}
            className={`hero-new-bg-img ${index === currentBg ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
        <div className="hero-new-overlay"></div>
      </div>

      <div className="hero-new-container">
        {/* Left Content */}
        <div className="hero-new-left">
          <div className="hero-new-badge">
            <FaMedal className="badge-icon" />
            <span>India's Most Trusted Agency</span>
          </div>

          <h1 className="hero-new-title">
            <span className="title-brand">Indian-Detective Agency</span>
            <span className="title-main">We Uncover The</span>
            <span className="title-accent">Truth You Deserve</span>
            
          </h1>

          <p className="hero-new-description">
            Providing confidential, reliable, and result-oriented detective services 
            for personal, corporate, and legal matters across India with 98% success rate.
          </p>

          <div className="hero-new-buttons">
            <Link to="/contact-us" className="btn-new-primary">
              <FaPhoneAlt />
              Free Consultation
              <FaArrowRight />
            </Link>
            <Link to="/services" className="btn-new-secondary">
              <FaPlay />
              Our Services
            </Link>
          </div>

          <div className="hero-new-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-new-item">
                <div className="stat-new-icon">{stat.icon}</div>
                <div>
                  <div className="stat-new-value">{stat.value}</div>
                  <div className="stat-new-label">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Content - Contact Card */}
        <div className="hero-new-right">
          <div className="contact-card">
            <div className="contact-card-header">
              <div className="header-dot"></div>
              <span>Get Free Consultation</span>
            </div>
            <h3>Need Help? Contact Us Now</h3>
            <p>Our experts are available 24/7 to assist you with your investigation needs.</p>
            <a href="tel:+917428203483" className="contact-card-phone">
              <FaPhoneAlt />
              +91 7428203483
            </a>
            <div className="contact-card-features">
              <div className="feature">
                <FaHandshake />
                <span>Free Consultation</span>
              </div>
              <div className="feature">
                <FaRocket />
                <span>Quick Response</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hero-new-scroll">
        <span>Scroll</span>
        <div className="scroll-line"></div>
      </div>

      {/* Slide Dots */}
      <div className="hero-new-dots">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentBg ? "active" : ""}`}
            onClick={() => setCurrentBg(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;